import axiosApiInstance from "../../../app/axios";
import { PARKIT_API_BASE_URL } from "../../../app/utils";
import { getJwtToken } from "../../../app/common";

export const getReferralClaims = async (
  page,
  size,
  campaignId,
  payoutStatus,
  cooledOff,
  referrerUserId,
  sort,
  sortBy
) => {
  let url = `${PARKIT_API_BASE_URL}/parkit/v2/referrals/claims?page=${page}&size=${size}&sort=${sort}&sortBy=${sortBy}`;
  if (campaignId) {
    url += `&referralCampaignId=${encodeURIComponent(campaignId)}`;
  }
  if (payoutStatus && payoutStatus !== "all") {
    url += `&payoutStatus=${payoutStatus}`;
  }
  // Splits payable claims into those past cooling off and those still waiting
  if (cooledOff !== null && cooledOff !== undefined) {
    url += `&cooledOff=${cooledOff}`;
  }
  if (referrerUserId) {
    url += `&referrerUserId=${encodeURIComponent(referrerUserId)}`;
  }
  return axiosApiInstance.get(url, {
    headers: { Authorization: `Bearer ${getJwtToken()}` },
  });
};

export const updatePayoutStatus = async (claimIds) =>
  axiosApiInstance.put(
    `${PARKIT_API_BASE_URL}/parkit/v2/referrals/claims`,
    claimIds,
    { headers: { Authorization: `Bearer ${getJwtToken()}` } }
  );

export const voidReferralClaim = async (claimId) =>
  axiosApiInstance.put(
    `${PARKIT_API_BASE_URL}/parkit/v2/referrals/claims/${encodeURIComponent(
      claimId
    )}/void`,
    null,
    { headers: { Authorization: `Bearer ${getJwtToken()}` } }
  );
